import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { ModalResponse } from '../../enum/ModalResponse';
import { useTranslation } from 'react-i18next';

export interface ModalMeterConsentDeclineProps extends ModalProps {}
export default function ModalMeterConsentDecline({
  isOpen,
  onClickAction,
  onClose,
}: ModalMeterConsentDeclineProps) {
  const { t } = useTranslation();
  const [modalResponse, setModalResponse] = useState<ModalResponse | undefined>();

  const handleClickNo = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClickYes = () => {
    setModalResponse(ModalResponse.OK);
    if (onClickAction) {
      onClickAction(ModalResponse.OK);
    }
  };

  const handleOnClose = (response: ModalResponse | undefined) => {
    if (onClose) {
      onClose(response);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      actions={
        <Fragment>
          <Button className="btn btn--secondary mr-4 modal__actions__first" onClick={handleClickNo}>
            {t('common.no')}
          </Button>
          <Button className="btn btn--primary" onClick={handleClickYes}>
            {t('common.yes')}
          </Button>
        </Fragment>
      }
      onClose={() => handleOnClose(modalResponse)}
    >
      <Fragment>
        <p className="modal__message">{t('modal.meter.consent.decline.message.one')}</p>

        <p className="modal__message">{t('modal.meter.consent.decline.message.two')}</p>
      </Fragment>
    </Modal>
  );
}
